import { render, staticRenderFns } from "./Nuevo-proveedor.vue?vue&type=template&id=bf6f0f16&scoped=true"
import script from "./Nuevo-proveedor.vue?vue&type=script&lang=js"
export * from "./Nuevo-proveedor.vue?vue&type=script&lang=js"
import style0 from "./Nuevo-proveedor.vue?vue&type=style&index=0&id=bf6f0f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6f0f16",
  null
  
)

export default component.exports